<script lang="ts" setup>
  import type * as CSS from 'csstype'

  withDefaults(
    defineProps<{
      backgroundColor?: CSS.Property.BackgroundColor
      size?: 'XS' | 'S' | 'M' | 'L' | 'XL'
    }>(),
    {
      backgroundColor: 'transparent',
      size: 'M'
    }
  )
</script>

<template>
  <div :class="['c-spacer', `c-spacer-${size.toLowerCase()}`]" />
</template>

<style lang="scss" scoped>
  .c-spacer {
    display: block;
    width: 100%;
    background-color: v-bind('backgroundColor');
  }

  .c-spacer-xs {
    height: 12px;

    @include screenMdAndUp {
      height: 16px;
    }
  }

  .c-spacer-s {
    height: 16px;

    @include screenMdAndUp {
      height: 24px;
    }
  }

  .c-spacer-m {
    height: 40px;

    @include screenMdAndUp {
      height: 48px;
    }
  }

  .c-spacer-l {
    height: 48px;

    @include screenMdAndUp {
      height: 64px;
    }
  }

  .c-spacer-xl {
    height: 80px;

    @include screenMdAndUp {
      height: 96px;
    }
  }
</style>
